// import "./Ellipsis.scss";

import type { IControllerConstructor, IDirective, Injectable } from "angular";
import { module } from "angular";

import KendoGridModifierDirectiveController from "./KendoGridModifierDirectiveController";

export default class KendoGridModifierDirective implements IDirective {
    public bindToController = {
        mmGridModifier: "<",
    };

    public controller: Injectable<IControllerConstructor>;

    public controllerAs = "$ctrl";

    public restrict = "A";

    public scope = {};

    constructor() {
        this.controller = KendoGridModifierDirectiveController;
    }
}

module("mmGui").directive("mmGridModifier", () => new KendoGridModifierDirective());
